<template>
  <div class="news">
    <div class="banner">
      <div class="header">
        <img src="@/assets/imgs/logo-qinlian.png" alt="" class="logo" />
        <img src="@/assets/imgs/mrightbtn.png"  @click="drawer = true" alt="" class="logo-btn-img">
      </div>
    </div>
    <div class="new-content">
        <p>{{newsData.title}}</p>
        <!-- <div class="sanjiao"></div> -->
        <i class="el-icon-caret-bottom" style="color: #409EFF"></i>
        <div v-html="newsData.content" class="news-content">
        </div>
      </div>
    
  </div>
</template>
<script>
import MyHeader from '@/components/newHeader.vue'
import MobilenewHeader from '@/components/MobilenewHeader.vue'
import NewItem from "@/components/NewItem.vue";
import PageMixin from "@/assets/js/pageMixin";
export default {
  mixins: [PageMixin],
  data() {
    return {
      newId:"",
      newsList: [
        {
          title: "农产品溯源系统解析，没有更全的了！",
          text:
            "我国是农业大国，但农业发展举步维艰，农产品安全问题更是屡见报端，虽然管理部门积极采取措施，加强各方面的管理和监督，但效果一直不理想...",
          time: "2018-04-27",
          route: "/new1"
        },
        {
          title: "区块链技术为传统种业赋能，有助于解决农业诸多问题",
          text:
            "区块链技术应用在种业领域，有利于遏制侵权假冒行为、维护市场公平竞争、保护农民合法权益...",
          time: "2018-07-23",
          route: "/new2"
        },
        {
          title: "2018“区块链+农业”引爆颠覆性变革，将为农业带来什么？",
          text:
            "无论你在什么行业，想必这两天都能在朋友圈里看到关于区块链（Block Chain）的各种新闻。2018新年伊始，轰轰烈烈的区块链猝不及防进入农业人的视野...",
          time: "2018-02-27",
          route: "/new3"
        },
        {
          title: "基于区块链农产品溯源解决方案",
          text:
            "质量安全问题，是当前政府重视、社会关注的热点，不仅关系到公众的身体健康，商品质量追溯是对商品生产全过程的信息跟踪与追溯...",
          time: "2018-07-12",
          route: "/new4"
        }
      ],
      titleLabels: {
        1: '新闻动态',
        2: '信链资讯',
        3: '媒体视角'
      },
      showNewIndex: null,
      signleNew: {},
      activeName: "1",
      index: 1,
      newsData:{}

    };
  },
  mounted() {
     this.newId=this.$route.query.id
    this.getNewsDetail(1);
  },
  methods: {
    async getNewsDetail() {
      let res = await this.$fetch(
        "/user/api/v1/newsGet",
        {
          id: this.newId,
          
        },
        "POST"
      );
      if (res.code == 200) {
        this.newsData=res.data
        // this.newsList = res.data.data;
        // console.log(res.data.countSize)
        // this.dataTotalLength = res.data.countSize;
      }
    },
    async getSingleNew(id) {
      let res = await this.$request.get("/open/trace/product/wechat/queryNewsById", { id });
      if (res.code == 0) {
        this.showNewIndex = true;
        this.signleNew = res.data;
      }
    },
    async getCodeList(page) {
      let res = await this.$request.post(
        "/open/trace/product/wechat/queryNewsPage",
        {
          newsStatus: 1,
          newsType: this.activeName,
          limit: 5,
          page
        }
      );
      if (res.code == 0) {
        this.newsList = res.data.data;
        console.log(res.data.countSize)
        this.dataTotalLength = res.data.countSize;
      }
    },
    handleTabClick(tab) {
      this.index = 1;
      this.showNewIndex = false;
      this.activeName = tab.name;
      // this.getCodeList(1);
    },
    changeSize(val) {
      // this.getCodeList(val)
    }
  },
  components: {
    NewItem,
    MyHeader,
    MobilenewHeader

  },
  watch: {
    activeName(val) {
      this.showNewIndex = false;
      // this.getCodeList(1);
    }
  },
  beforeRouteEnter(to, from, next) {
    next(async vm => {
      if (to.query.id) {
        // vm.getSingleNew(to.query.id);
        vm.showNewIndex = true;
      }
      if (to.query.ac) {
        vm.activeName = to.query.ac
      }
    });
  }
};
</script>
<style lang="less" >
.news{
  .banner{
    .header {
    display: flex;
    justify-content: space-between;
    height: 68px;
    // border-bottom: solid 1px springgreen;
    border-bottom: 1px solid #dfdfdd;
    .logo {
      width: 150px;
      height: 50px;
      margin-left: 20px;
      margin-top: 10px;
    }
    .logo-btn-img{
      width: 30px;
      height: 30px;
      margin-right: 20px;
      margin-top: 22px;
      // cursor: pointer;
    }
    .con:hover{
      background:GhostWhite;
    }
    .log:hover{
      background:GhostWhite;

    }
    
  }
  
  }
  .new-content{
    // width: 100%;
    // position: relative;
    // height: 52px;
    // background: url('../../assets/imgs/us.png') no-repeat;
    // background-size: 100% 100%;
    margin: 0 20px;
    p{
      font-size: 16px;
      font-family: PingFang SC;
      color: #333333;
      line-height: 44px;
    }
    .sanjiao{
      width: 12px;
      height: 8px;
      background: #409EFF;
    }
    img {
    width: 100%;
    display: block;
    margin: 20px auto;
  }
  }

}
</style>
